module.exports = __webpack_public_path__ + "static/media/modalReporteHistorico.c8eb2358.png";